import { Plugin } from './plugin';
import { LoggerService } from 'rainbow-web-sdk/services/core/logger.service';
import { Office365AdService } from 'rainbow-web-sdk/services/directory/office365ad.service';

export class Microsoft0365AdPlugin extends Plugin {
    public static initialize(): Microsoft0365AdPlugin {
        Plugin.initialize();

        if (!window.rainbow.plugins[Microsoft0365AdPlugin.name]) {
            const logger = LoggerService.getInstance();
            logger.info("[Microsoft0365AdPlugin] initialized");
            window.rainbow.plugins[Microsoft0365AdPlugin.name] = new Microsoft0365AdPlugin();
            Office365AdService.getInstance();
        }
        return window.rainbow.plugins[Microsoft0365AdPlugin.name];
    }

    private constructor() {
        super();
    }
}
